import React from 'react';
import { Row, Col } from 'shards-react';
import MainNavbar from './MainNavbar/MainNavbar';
import MainSidebar from './MainSidebar/MainSidebar';
import MainFooter from './MainFooter/MainFooter';

const DefaultLayout = ({ children, location: { pathname } }) => (
	<Row>
		<MainSidebar pathname={pathname} />
		<Col tag='main' className='main-content p-0 min-vh-100 d-grid template-rows-auto-fr'>
			<MainNavbar />
			{children}
			<MainFooter />
		</Col>
	</Row>
);

export default DefaultLayout;
